// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fgR05A {
  display: flex;
  flex-direction: column;
  width: 100%;
  box-sizing: border-box;
  margin-top: var(--spacing-7);
}

.UY2hZ9 {
  display: block;
  width: 100%;
  box-sizing: border-box;
  padding: var(--spacing-4) 0 var(--spacing-3);
  border: 1px solid var(--stroke-neutral-silver, #cccccc);
  border-radius: var(--card-border-radius, 8px);
  background: transparent;
}

.ZPIGpq {
  width: 100%;
  margin-top: var(--spacing-4);
  box-sizing: border-box;
}

.YgkGiX {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-3);
  width: 100%;
  box-sizing: border-box;
  padding-inline: var(--spacing-3);
}

.EevUS2 {
  margin: 0;
  font-size: var(--font-size-3xl);
  font-weight: var(--font-weight-medium);
  line-height: 100%;
  color: var(--text-neutral-dark);
  font-family: var(--font-family-clario), var(--font-family-base);
  text-align: left;
}

.GDAGqw {
  color: var(--brand-tr-orange);
  font-weight: var(--font-weight-bold);
}

.o7st45 {
  margin: 0;
  font-size: var(--font-size-lg);
  line-height: normal;
  font-weight: var(--font-weight-regular);
  color: var(--text-neutral-dark);
  font-family: var(--font-family-base);
}

.yAr5KX {
  display: flex;
  flex-direction: row;
  align-items: stretch;
  gap: var(--spacing-3);
  width: 100%;
  box-sizing: border-box;
  padding-left: var(--spacing-3);
  padding-right: var(--spacing-3);
  overflow-x: auto;
  overflow-y: hidden;
  scrollbar-width: none;
  -ms-overflow-style: none;
}

.yAr5KX::-webkit-scrollbar {
  display: none;
}

.qCfEc6 {
  position: relative;
  flex: 0 0 calc((100% - 2 * var(--spacing-3)) / 3);
  min-width: 0;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: var(--spacing-3);
  padding: var(--spacing-3);
  background: var(--surface-neutral-white, #fff);
  border-radius: var(--card-border-radius, 8px);
}

.AQg6ea {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--spacing-1-5);
}

.bvfctF {
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 2.5rem;
  height: 2.5rem;
}

.bvfctF svg,
.bvfctF img {
  display: block;
  width: 100%;
  height: 100%;
}

.LFRm6t {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 8rem;
  padding-inline: var(--spacing-3);
}

.WDDsu9 {
  margin: 0;
  padding-inline: var(--spacing-3);
  font-size: var(--font-size-md);
  line-height: normal;
  font-weight: var(--font-weight-regular);
  color: var(--text-neutral-dark);
  font-family: var(--font-family-base);
  text-align: center;
}

.VAXALn {
  margin: 0;
  font-size: var(--font-size-2xl);
  font-weight: var(--font-weight-medium);
  line-height: 100%;
  color: var(--brand-tr-orange);
  font-family: var(--font-family-clario), var(--font-family-base);
  text-align: center;
}

.C5V6dN {
  margin: 0;
  align-self: stretch;
  font-size: var(--font-size-md);
  line-height: normal;
  font-weight: var(--font-weight-regular);
  color: var(--text-neutral-dark);
  font-family: var(--font-family-base);
  text-align: center;
}

.lov97f {
  position: absolute;
  top: var(--spacing-1-5);
  right: var(--spacing-1-5);
  display: inline-flex;
  align-items: center;
  padding: var(--spacing-0-5) 6px;
  border: 1px solid var(--success-green-dark, #387c2b);
  border-radius: 4px;
  background: var(--success-green-light, #eef8ec);
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-regular);
  line-height: 1;
  color: var(--text-neutral-dark);
  font-family: var(--font-family-base);
  white-space: nowrap;
}

.JrR6uj {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 0.625rem;
  width: 100%;
  margin-top: var(--spacing-3);
}

.XT_Lo_ {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: var(--spacing-1-5);
  border: 1px solid var(--brand-tr-orange);
  border-radius: 4px;
  background: var(--surface-neutral-white, #fff);
  cursor: pointer;
  transition:
    transform 0.15s ease,
    box-shadow 0.15s ease,
    border-color 0.2s ease;
}

.XT_Lo_:not(:disabled):hover {
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12);
}

.XT_Lo_:not(:disabled):active {
  transform: translateY(0);
  box-shadow: none;
}

.XT_Lo_:disabled {
  border-color: var(--stroke-neutral-silver, #cccccc);
  cursor: not-allowed;
}

.MF9uCD {
  width: 1rem;
  height: 1rem;
  display: block;
}
`, "",{"version":3,"sources":["webpack://./../../packages/beneficios/src/pages/InsideSalesBenefitsLanding/components/InsideSalesProductPortfolioSection/InsideSalesProductPortfolioSection.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,sBAAsB;EACtB,4BAA4B;AAC9B;;AAEA;EACE,cAAc;EACd,WAAW;EACX,sBAAsB;EACtB,4CAA4C;EAC5C,uDAAuD;EACvD,6CAA6C;EAC7C,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,4BAA4B;EAC5B,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,WAAW;EACX,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,+BAA+B;EAC/B,sCAAsC;EACtC,iBAAiB;EACjB,+BAA+B;EAC/B,+DAA+D;EAC/D,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;EAC7B,oCAAoC;AACtC;;AAEA;EACE,SAAS;EACT,8BAA8B;EAC9B,mBAAmB;EACnB,uCAAuC;EACvC,+BAA+B;EAC/B,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,oBAAoB;EACpB,qBAAqB;EACrB,WAAW;EACX,sBAAsB;EACtB,8BAA8B;EAC9B,+BAA+B;EAC/B,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;EACrB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,iDAAiD;EACjD,YAAY;EACZ,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,qBAAqB;EACrB,yBAAyB;EACzB,8CAA8C;EAC9C,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,cAAc;AAChB;;AAEA;;EAEE,cAAc;EACd,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,gCAAgC;EAChC,8BAA8B;EAC9B,mBAAmB;EACnB,uCAAuC;EACvC,+BAA+B;EAC/B,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,+BAA+B;EAC/B,sCAAsC;EACtC,iBAAiB;EACjB,6BAA6B;EAC7B,+DAA+D;EAC/D,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,uCAAuC;EACvC,+BAA+B;EAC/B,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,yBAAyB;EACzB,oBAAoB;EACpB,mBAAmB;EACnB,+BAA+B;EAC/B,oDAAoD;EACpD,kBAAkB;EAClB,+CAA+C;EAC/C,8BAA8B;EAC9B,uCAAuC;EACvC,cAAc;EACd,+BAA+B;EAC/B,oCAAoC;EACpC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,WAAW;EACX,4BAA4B;AAC9B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,2BAA2B;EAC3B,wCAAwC;EACxC,kBAAkB;EAClB,8CAA8C;EAC9C,eAAe;EACf;;;0BAGwB;AAC1B;;AAEA;EACE,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,mDAAmD;EACnD,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB","sourcesContent":[".section {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  box-sizing: border-box;\n  margin-top: var(--spacing-7);\n}\n\n.box {\n  display: block;\n  width: 100%;\n  box-sizing: border-box;\n  padding: var(--spacing-4) 0 var(--spacing-3);\n  border: 1px solid var(--stroke-neutral-silver, #cccccc);\n  border-radius: var(--card-border-radius, 8px);\n  background: transparent;\n}\n\n.viewport {\n  width: 100%;\n  margin-top: var(--spacing-4);\n  box-sizing: border-box;\n}\n\n.header {\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-3);\n  width: 100%;\n  box-sizing: border-box;\n  padding-inline: var(--spacing-3);\n}\n\n.title {\n  margin: 0;\n  font-size: var(--font-size-3xl);\n  font-weight: var(--font-weight-medium);\n  line-height: 100%;\n  color: var(--text-neutral-dark);\n  font-family: var(--font-family-clario), var(--font-family-base);\n  text-align: left;\n}\n\n.highlight {\n  color: var(--brand-tr-orange);\n  font-weight: var(--font-weight-bold);\n}\n\n.subtitle {\n  margin: 0;\n  font-size: var(--font-size-lg);\n  line-height: normal;\n  font-weight: var(--font-weight-regular);\n  color: var(--text-neutral-dark);\n  font-family: var(--font-family-base);\n}\n\n.track {\n  display: flex;\n  flex-direction: row;\n  align-items: stretch;\n  gap: var(--spacing-3);\n  width: 100%;\n  box-sizing: border-box;\n  padding-left: var(--spacing-3);\n  padding-right: var(--spacing-3);\n  overflow-x: auto;\n  overflow-y: hidden;\n  scrollbar-width: none;\n  -ms-overflow-style: none;\n}\n\n.track::-webkit-scrollbar {\n  display: none;\n}\n\n.card {\n  position: relative;\n  flex: 0 0 calc((100% - 2 * var(--spacing-3)) / 3);\n  min-width: 0;\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  gap: var(--spacing-3);\n  padding: var(--spacing-3);\n  background: var(--surface-neutral-white, #fff);\n  border-radius: var(--card-border-radius, 8px);\n}\n\n.cardHeader {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: var(--spacing-1-5);\n}\n\n.cardIcon {\n  flex-shrink: 0;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 2.5rem;\n  height: 2.5rem;\n}\n\n.cardIcon svg,\n.cardIcon img {\n  display: block;\n  width: 100%;\n  height: 100%;\n}\n\n.status {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 8rem;\n  padding-inline: var(--spacing-3);\n}\n\n.statusMessage {\n  margin: 0;\n  padding-inline: var(--spacing-3);\n  font-size: var(--font-size-md);\n  line-height: normal;\n  font-weight: var(--font-weight-regular);\n  color: var(--text-neutral-dark);\n  font-family: var(--font-family-base);\n  text-align: center;\n}\n\n.cardTitle {\n  margin: 0;\n  font-size: var(--font-size-2xl);\n  font-weight: var(--font-weight-medium);\n  line-height: 100%;\n  color: var(--brand-tr-orange);\n  font-family: var(--font-family-clario), var(--font-family-base);\n  text-align: center;\n}\n\n.cardDescription {\n  margin: 0;\n  align-self: stretch;\n  font-size: var(--font-size-md);\n  line-height: normal;\n  font-weight: var(--font-weight-regular);\n  color: var(--text-neutral-dark);\n  font-family: var(--font-family-base);\n  text-align: center;\n}\n\n.patTag {\n  position: absolute;\n  top: var(--spacing-1-5);\n  right: var(--spacing-1-5);\n  display: inline-flex;\n  align-items: center;\n  padding: var(--spacing-0-5) 6px;\n  border: 1px solid var(--success-green-dark, #387c2b);\n  border-radius: 4px;\n  background: var(--success-green-light, #eef8ec);\n  font-size: var(--font-size-sm);\n  font-weight: var(--font-weight-regular);\n  line-height: 1;\n  color: var(--text-neutral-dark);\n  font-family: var(--font-family-base);\n  white-space: nowrap;\n}\n\n.nav {\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  gap: 0.625rem;\n  width: 100%;\n  margin-top: var(--spacing-3);\n}\n\n.navButton {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  padding: var(--spacing-1-5);\n  border: 1px solid var(--brand-tr-orange);\n  border-radius: 4px;\n  background: var(--surface-neutral-white, #fff);\n  cursor: pointer;\n  transition:\n    transform 0.15s ease,\n    box-shadow 0.15s ease,\n    border-color 0.2s ease;\n}\n\n.navButton:not(:disabled):hover {\n  transform: translateY(-1px);\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12);\n}\n\n.navButton:not(:disabled):active {\n  transform: translateY(0);\n  box-shadow: none;\n}\n\n.navButton:disabled {\n  border-color: var(--stroke-neutral-silver, #cccccc);\n  cursor: not-allowed;\n}\n\n.navIcon {\n  width: 1rem;\n  height: 1rem;\n  display: block;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"section": `fgR05A`,
	"box": `UY2hZ9`,
	"viewport": `ZPIGpq`,
	"header": `YgkGiX`,
	"title": `EevUS2`,
	"highlight": `GDAGqw`,
	"subtitle": `o7st45`,
	"track": `yAr5KX`,
	"card": `qCfEc6`,
	"cardHeader": `AQg6ea`,
	"cardIcon": `bvfctF`,
	"status": `LFRm6t`,
	"statusMessage": `WDDsu9`,
	"cardTitle": `VAXALn`,
	"cardDescription": `C5V6dN`,
	"patTag": `lov97f`,
	"nav": `JrR6uj`,
	"navButton": `XT_Lo_`,
	"navIcon": `MF9uCD`
};
module.exports = ___CSS_LOADER_EXPORT___;
